import { ContainedIcon } from '@frontend/icons';

export const Transferred = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: 'var(--fabric-radius-sm)',
      }}
      iconName='call-source'
      color={'var(--fabric-color-neutral-50)'}
    />
  );
};
